export const RECENT_COLOR_LIMIT = 14

export function getCornerFactors(x, y, threshold = 0.02) {
  // Calculate distance to each corner
  const distToTopLeft = Math.sqrt(x * x + (1-y) * (1-y))
  const distToTopRight = Math.sqrt((1-x) * (1-x) + (1-y) * (1-y))
  const distToBottomLeft = Math.sqrt(x * x + y * y)
  const distToBottomRight = Math.sqrt((1-x) * (1-x) + y * y)
  
  // Find closest corner
  const corners = [
    { name: 'topLeft', dist: distToTopLeft },
    { name: 'topRight', dist: distToTopRight },
    { name: 'bottomLeft', dist: distToBottomLeft },
    { name: 'bottomRight', dist: distToBottomRight }
  ]
  
  corners.sort((a, b) => a.dist - b.dist)
  const closestCorner = corners[0].name
  
  // Default all corners to full radius
  const factors = {
    topLeft: 1,
    topRight: 1,
    bottomLeft: 1,
    bottomRight: 1
  }
  
  // Calculate threshold distance (as percentage of diagonal)
  const thresholdDist = threshold * Math.sqrt(2)
  
  // Only modify the closest corners' radius
  if (corners[0].dist < thresholdDist) {
    // Calculate factor based on how close we are
    const factor = corners[0].dist / thresholdDist
    factors[closestCorner] = factor
  }
  
  return factors
}

// translate into CSS border-radius values
export function factorsToBorderRadius(factors, defaultRadius = '1em') {
  const radiusValue = parseFloat(defaultRadius)
  const radiusUnit = defaultRadius.replace(/[\d.]/g, '')
  
  const topLeft = `${radiusValue * factors.topLeft}${radiusUnit}`
  const topRight = `${radiusValue * factors.topRight}${radiusUnit}`
  const bottomRight = `${radiusValue * factors.bottomRight}${radiusUnit}`
  const bottomLeft = `${radiusValue * factors.bottomLeft}${radiusUnit}`
  
  return `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`
}

export function getSaturationBorderRadius(s, v, defaultRadius = '1em') {
  const x = s / 100
  const y = v / 100
  
  const factors = getCornerFactors(x, y)
  return factorsToBorderRadius(factors, defaultRadius)
}
